export default "__VITE_ASSET__7e79ae4e__"